import React from "react";
import { Row, Col } from "react-flexbox-grid";

import { SelectField, If, CurrencyField } from "components/support";
import {
  PisValues,
  CofinsValues,
  OriginValues,
  CsosnValues,
  CfopValues,
  ModbcValues,
  ModbcstValues,
  MotdesicmsValues,
  IcmsValues
} from "core/enum";
import Typography from "material-ui-next/Typography";
import Paper from "material-ui-next/Paper";

import styles from "./styles";

const AccountantAreaFiscalInfoView = props => {
  const { className, company, onChange, onChangeDefaultTaxes, errors } = props;
  const { default_taxes, fiscal_informations } = company;
  const { cst } = default_taxes;

  const disablePisCofins = cst === "99";

  return (
    <div className={`${className} grid-container`}>
      <Row>
        <Col xs={12}>
          <div className="grid-container mt-sm mb-sm">
            <If test={fiscal_informations.crt_code === "3"}>
              <Row>
                <Paper
                  elevation={3}
                  style={{ width: "100%", padding: 8, margin: "10px 0" }}
                >
                  <Typography type="title">PIS</Typography>
                  <SelectField
                    fullWidth
                    options={PisValues}
                    label="CST"
                    required={true}
                    errorText={errors["default_taxes.pis_normal.cst"]}
                    disabled={
                      fiscal_informations.crt_code === "3" ? false : true
                    }
                    value={
                      default_taxes.pis_normal
                        ? default_taxes.pis_normal.cst || ""
                        : ""
                    }
                    onChange={(_, value) =>
                      onChangeDefaultTaxes("pis_normal", "cst", value)
                    }
                  />

                  <If
                    test={
                      default_taxes.pis_normal &&
                      ["01", "02", "49", "99"].includes(
                        default_taxes.pis_normal.cst
                      )
                    }
                  >
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      value={
                        default_taxes.pis_normal
                          ? default_taxes.pis_normal.pPIS || "0"
                          : ""
                      }
                      label="Alíquota do PIS (em %)"
                      suffix=" %"
                      required={true}
                      errorText={
                        default_taxes.pis_normal &&
                        !default_taxes.pis_normal.pPIS
                          ? "Preenchimento obrigatório"
                          : ""
                      }
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("pis_normal", "pPIS", value)
                      }
                    />
                  </If>

                  <If
                    test={
                      default_taxes.pis_normal &&
                      ["03"].includes(default_taxes.pis_normal.cst)
                    }
                  >
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      required={true}
                      errorText={
                        default_taxes.pis_normal &&
                        !default_taxes.pis_normal.vAliqProd
                          ? "Preenchimento obrigatório"
                          : ""
                      }
                      fullWidth
                      value={
                        default_taxes.pis_normal
                          ? default_taxes.pis_normal.vAliqProd || "0"
                          : ""
                      }
                      label="Alíquota do PIS (em R$)"
                      unit="R$ "
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("pis_normal", "vAliqProd", value)
                      }
                    />
                  </If>
                </Paper>
              </Row>

              <Row>
                <Paper
                  elevation={3}
                  style={{ width: "100%", padding: 8, margin: "10px 0" }}
                >
                  <Typography type="title">COFINS</Typography>
                  <SelectField
                    fullWidth
                    options={CofinsValues}
                    label="CST"
                    errorText={errors["default_taxes.cofins_normal.cst"]}
                    disabled={
                      fiscal_informations.crt_code === "3" ? false : true
                    }
                    value={
                      default_taxes.cofins_normal
                        ? default_taxes.cofins_normal.cst || ""
                        : ""
                    }
                    onChange={(_, value) =>
                      onChangeDefaultTaxes("cofins_normal", "cst", value)
                    }
                  />

                  <If
                    test={
                      default_taxes.cofins_normal &&
                      ["01", "02", "49"].includes(
                        default_taxes.cofins_normal.cst
                      )
                    }
                  >
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      required={true}
                      errorText={
                        default_taxes.cofins_normal &&
                        !default_taxes.cofins_normal.pCOFINS
                          ? "Preenchimento obrigatório"
                          : ""
                      }
                      unit=""
                      value={
                        default_taxes.cofins_normal
                          ? default_taxes.cofins_normal.pCOFINS || "0"
                          : ""
                      }
                      label="Alíquota do COFINS (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("cofins_normal", "pCOFINS", value)
                      }
                    />
                  </If>

                  <If
                    test={
                      default_taxes.cofins_normal &&
                      ["03"].includes(default_taxes.cofins_normal.cst)
                    }
                  >
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      fullWidth
                      required={true}
                      errorText={
                        default_taxes.cofins_normal &&
                        !default_taxes.cofins_normal.vAliqProd
                          ? "Preenchimento obrigatório"
                          : ""
                      }
                      value={
                        default_taxes.cofins_normal
                          ? default_taxes.cofins_normal.vAliqProd || "0"
                          : ""
                      }
                      label="Alíquota do COFINS (em R$)"
                      unit="R$ "
                      onChange={(_, value) =>
                        onChangeDefaultTaxes(
                          "cofins_normal",
                          "vAliqProd",
                          value
                        )
                      }
                    />
                  </If>
                </Paper>
              </Row>

              <Row>
                <Paper
                  elevation={3}
                  style={{ width: "100%", padding: 8, margin: "10px 0" }}
                >
                  <Typography type="title">ICMS</Typography>
                  <SelectField
                    fullWidth
                    options={IcmsValues}
                    errorText={errors["default_taxes.icms.cst"]}
                    label="CST"
                    disabled={
                      fiscal_informations.crt_code === "3" ? false : true
                    }
                    value={
                      default_taxes.icms ? default_taxes.icms.cst || "" : ""
                    }
                    onChange={(_, value) =>
                      onChangeDefaultTaxes("icms", "cst", value)
                    }
                  />
                  <If
                    test={
                      default_taxes.icms &&
                      !["none", "", "30", "50"].includes(default_taxes.icms.cst)
                    }
                  >
                    <SelectField
                      fullWidth
                      label="CFOP"
                      required={true}
                      errorText={errors["default_taxes.icms.cfop"]}
                      options={
                        default_taxes.icms && default_taxes.icms.cst
                          ? CfopValues[default_taxes.icms.cst]
                          : []
                      }
                      value={
                        default_taxes.icms ? default_taxes.icms.cfop || "" : ""
                      }
                      onChange={(_, value) =>
                        onChangeDefaultTaxes(
                          "icms",
                          "cfop",
                          value !== "none" ? value.replace(/\D/g, "") : "none"
                        )
                      }
                    />
                  </If>

                  <If
                    test={
                      default_taxes.icms &&
                      ["00", "10", "20"].includes(default_taxes.icms.cst)
                    }
                  >
                    <SelectField
                      fullWidth
                      options={ModbcValues}
                      label="Modalidade de determinação da BC do ICMS"
                      required={true}
                      errorText={errors["default_taxes.icms.modBC"]}
                      value={
                        default_taxes.icms ? default_taxes.icms.modBC || "" : ""
                      }
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "modBC", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      required={true}
                      errorText={
                        default_taxes.icms && default_taxes.icms.pICMS === ""
                          ? "Preenchimento obrigatório"
                          : ""
                      }
                      unit=""
                      value={
                        default_taxes.icms ? default_taxes.icms.pICMS || "" : ""
                      }
                      label="Alíquota do imposto do ICMS (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pICMS", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pFCP === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pFCP || "0.00"
                          : "0.00"
                      }
                      label="Percentual do Fundo de Combate à Pobreza (FCP) (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pFCP", value)
                      }
                    />
                  </If>

                  <If
                    test={
                      default_taxes.icms &&
                      ["10", "30"].includes(default_taxes.icms.cst)
                    }
                  >
                    <SelectField
                      fullWidth
                      options={ModbcstValues}
                      label="Modalidade de determinação da BC do ICMS ST"
                      required={true}
                      errorText={errors["default_taxes.icms.modBCST"]}
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.modBCST || ""
                          : ""
                      }
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "modBCST", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pMVAST || "0"
                          : ""
                      }
                      label="Percentual da margem de valor Adicionado do ICMS ST (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pMVAST", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pRedBCST || "0"
                          : "0"
                      }
                      label="Percentual da Redução de BC do ICMS ST (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pRedBCST", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pICMSST === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pICMSST || "0"
                          : ""
                      }
                      label="Alíquota do imposto do ICMS ST (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pICMSST", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pFCPST === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pFCPST || "0"
                          : ""
                      }
                      label="Percentual do FCP retido por Substituição Tributária (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pFCPST", value)
                      }
                    />
                  </If>

                  <If
                    test={
                      default_taxes.icms &&
                      ["20"].includes(default_taxes.icms.cst)
                    }
                  >
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pRedBC || "0"
                          : ""
                      }
                      label="Percentual da Redução de BC do ICMS (em %)"
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pRedBC === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pRedBC", value)
                      }
                    />
                  </If>

                  <If
                    test={
                      default_taxes.icms &&
                      ["20", "30"].includes(default_taxes.icms.cst)
                    }
                  >
                    <SelectField
                      fullWidth
                      options={MotdesicmsValues}
                      label="Motivo da desoneração do ICMS."
                      required={true}
                      errorText={errors["default_taxes.icms.motDesICMS"]}
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.motDesICMS || ""
                          : ""
                      }
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "motDesICMS", value)
                      }
                    />
                  </If>
                  <If
                    test={
                      default_taxes.icms &&
                      ["60"].includes(default_taxes.icms.cst)
                    }
                  >
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pST === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      value={
                        default_taxes.icms ? default_taxes.icms.pST || "0" : "0"
                      }
                      label="Alíquota suportada pelo Consumidor Final (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pST", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pFCPSTRet === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pFCPSTRet || "0"
                          : "0"
                      }
                      label="Percentual do FCP retido anteriormente por Substituição Tributária (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pFCPSTRet", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pRedBCEfet === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pRedBCEfet || "0"
                          : "0"
                      }
                      label="Percentual de redução da base de cálculo efetiva (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pRedBCEfet", value)
                      }
                    />
                    <CurrencyField
                      allowNegative={false}
                      disabled={false}
                      precision={2}
                      separator=""
                      fullWidth
                      unit=""
                      value={
                        default_taxes.icms
                          ? default_taxes.icms.pICMSEfet || "0"
                          : "0"
                      }
                      required={true}
                      errorText={
                        default_taxes.icms
                          ? default_taxes.icms.pICMSEfet === ""
                            ? "Preenchimento obrigatório"
                            : ""
                          : ""
                      }
                      label="Alíquota do ICMS efetiva (em %)"
                      suffix=" %"
                      onChange={(_, value) =>
                        onChangeDefaultTaxes("icms", "pICMSEfet", value)
                      }
                    />
                  </If>
                </Paper>
              </Row>
            </If>

            <If test={["1", "2"].includes(fiscal_informations.crt_code)}>
              <Row>
                <Col xs={12}>
                  <SelectField
                    fullWidth
                    label="CSOSN"
                    options={CsosnValues}
                    errorText={errors["default_taxes.csosn"]}
                    value={default_taxes.csosn || ""}
                    onChange={(_, value) => onChange("csosn", value)}
                  />
                </Col>
                <If test={default_taxes.csosn}>
                  <Col xs={12}>
                    <SelectField
                      fullWidth
                      label="CFOP"
                      disabled={!default_taxes.csosn}
                      errorText={errors["default_taxes.cfop"]}
                      options={
                        default_taxes.csosn !== ""
                          ? CfopValues[default_taxes.csosn]
                          : []
                      }
                      value={default_taxes.cfop || ""}
                      onChange={(_, value) =>
                        onChange("cfop", value.replace(/\D/g, ""))
                      }
                    />
                  </Col>
                </If>
                <Col xs={12} lg={6}>
                  <SelectField
                    fullWidth
                    label="PIS"
                    disabled={disablePisCofins}
                    options={PisValues}
                    value={default_taxes.pis}
                    onChange={(_, value) => onChange("pis", value)}
                  />
                </Col>
                <Col xs={12} lg={6}>
                  <SelectField
                    fullWidth
                    disabled={disablePisCofins}
                    options={CofinsValues}
                    label="COFINS"
                    value={default_taxes.cofins}
                    onChange={(_, value) => onChange("cofins", value)}
                  />
                </Col>
              </Row>
            </If>
            <If test={["1", "2", "3"].includes(fiscal_informations.crt_code)}>
              <Row>
                <Col xs={12} lg={6}>
                  <SelectField
                    fullWidth
                    options={OriginValues}
                    label="ORIGEM"
                    value={default_taxes.origin}
                    onChange={(_, value) => onChange("origin", value)}
                  />
                </Col>
              </Row>
            </If>

            <If test={!["1", "2", "3"].includes(fiscal_informations.crt_code)}>
              <Row>
                <Typography
                  style={{
                    textAlign: "center",
                    margin: "20px auto",
                    padding: 10,
                    color: "red",
                    background: "#f7f7f7"
                  }}
                >
                  {" "}
                  Preencha o campo de CRT (Código de Regime Trabalhista){" "}
                </Typography>
              </Row>
            </If>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default styles(AccountantAreaFiscalInfoView);



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/fiscal-info/index.jsx